import ConfirmBox from "components/shared/VmwareMappingConfirmBox";
import { useState, useEffect } from "react";
import Breadcrumb from "components/shared/Breadcrumb";
import vmwareService from "services/admin/masters/vmwareService";
import Select from "react-select";
import MaterialTable from "material-table";
import { toast } from "react-toastify";
import { getMatrixId } from "utils/matriceHelpers";
import {
  MSG_COMBINE_KEY_WARNING,
  MSG_MAPPING_DELETE_WARNING,
  MSG_MAPPING_RESTORE_WARNING
} from "constants/admin/masters/vmware";
import {
  ERROR_MESSAGE_UNKNOWN,
  MSG_RECORD_CREATE, MSG_RECORD_DELETE,
  MSG_RECORD_UNDO_DELETE,
  MSG_RECORD_UPDATE
}
  from "constants/common";
function ManageVmwareCPUGen() {
  const [breadcrumbs, setBreadCrumbs] = useState([
    { title: "UCP VMware Masters Mapping", url: "/admin/master/ucp-vmware/" },
    { title: "Manage Mapping" },
  ]);

  const serviceObj = new vmwareService();
  const [combineKeyDetails, setCombinekeyDetails] = useState([]);
  const [selectedCombineKeys, setCombineKeys] = useState([]);
  const [cpuGenTableData, setCpuGenTableData] = useState([]);
  const [cpuGenerationDetails, setCpuGenerationDetails] = useState([]);
  const [selectedCpuGeneration, setSelectedCpuGeneration] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [isEditForm, setEditForm] = useState(false);
  const [editableItem, setEditableItem] = useState(null);
  const [showDeleteConfirmBox, setDeleteConfirmBoxFunction] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState("");
  const [itemToBeDeleted, setItemToBeDeleted] = useState(null);
  const [warningType, setWarningType] = useState(null);
  const Id = getMatrixId(window.location.pathname);


  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    serviceObj
      .getAllInitialData(Id)
      .then((response) => {
        setCpuGenTableData(response?.vmware_cpu_generation_mapping_list);
        let combineKeyList = response?.vmware_combine_keys.map((item) => {
          return {
            id: item.id,
            value: item.combine_key,
            label: item.combine_key,
          };
        });

        let cpuGenerationDropList = response?.cpu_generation_drop_list.map(
          (item) => {
            return {
              id: item.id,
              value: item.name,
              label: item.name,
              isDisabled: item.disabled
            };
          }
        );
        setCpuGenerationDetails(cpuGenerationDropList);
        setCombinekeyDetails(combineKeyList);
      })
      .catch((error) => {
        toast.error(ERROR_MESSAGE_UNKNOWN);
      });
  };
  // multi select dropdown function
  const selectMultipleValue = (selectedValues) => {
    setCombineKeys(selectedValues);
  };
  const resetForm = () => {
    setCombineKeys([]);
    setSelectedCpuGeneration(null);
    setErrorMessage("");
    setEditForm(false);
    setEditableItem(null);
    setWarningType("")
  };
  const addCPUGenerationMapping = (e) => {
    e.preventDefault()
    let selectedKeys = selectedCombineKeys.map(key => key.id);
    // // check validation
    if (selectedCpuGeneration === null || selectedCombineKeys.length === 0) {
      let message = "";
      if (selectedCpuGeneration === null && selectedCombineKeys.length === 0) {
        message = "Please select CPU Generation and Combine Key(s) from the dropdown!"
      }
      else if (selectedCpuGeneration === null) {
        message = "Please select CPU Generation!"
      } else if (selectedCombineKeys.length === 0) {
        message = MSG_COMBINE_KEY_WARNING;
      }
      setErrorMessage(message);
    }
    // call POST api
    else {
      let data = {
        cpu_generation_id: selectedCpuGeneration.id,
        vmware_combine_keys: selectedKeys
      }
      serviceObj.createCPUGenerationMapping(data).then((response) => {
        toast.success(MSG_RECORD_CREATE);
        getData();
        resetForm();
        setErrorMessage("")
      })
    }
  };
  // edit form
  const editForm = (data) => {
    setEditForm(true);
    // call get api to get edit cpld details.
    serviceObj.getCPUGenKeyDetails(data.id).then((response) => {
      // storing editable item details in local state for final edit api
      setEditableItem(response)
      let item = response?.record_details;
      let cpuGenValue = {
        id: item.cpu_generation_id,
        value: item.cpu_generation,
        label: item.cpu_generation
      };

      let combineKeys = response?.vmware_combine_keys.map((item) => {
        return {
          id: item.id,
          value: item.combine_key,
          label: item.combine_key,
        }
      })

      // set edit form values
      setSelectedCpuGeneration(cpuGenValue);
      setCombineKeys(combineKeys)
    });
  };
  // update CPLD
  const updateCPLDMapping = (e) => {
    e.preventDefault();
    let selectedKeys = selectedCombineKeys.map(key => key.id);
    let data = {
      cpu_generation_id: selectedCpuGeneration.id,
      vmware_combine_keys: selectedKeys
    }
    let ID = editableItem.record_details.cpu_generation_id;
    serviceObj.updateCPUGenMapping(ID, data).then((response) => {
      toast.success(MSG_RECORD_UPDATE);
      getData();
      resetForm();
    }).catch((error) => toast.error(ERROR_MESSAGE_UNKNOWN))
  };
  // delete CPU Gen function
  const deleteCPUGenFunction = () => {
    let ID = itemToBeDeleted.id;
    serviceObj.deleteCPUGenMapping(ID)
      .then((response) => {
        let toastMessage = warningType === "restore" ? MSG_RECORD_UNDO_DELETE : MSG_RECORD_DELETE;
        toast.success(toastMessage);
        setDeleteConfirmBoxFunction(false)
        setConfirmMessage("");
        getData();
        setItemToBeDeleted(null);
      }).catch((error) => {
        toast.error(ERROR_MESSAGE_UNKNOWN);
        setDeleteConfirmBoxFunction(false)
        setConfirmMessage("");
        getData();
        setItemToBeDeleted(null);
      })
  };

  // show warning confirmation popup
  const showWarning = (rowData) => {
    let type = rowData.is_deleted ? "restore" : "delete";
    setWarningType(type);
    let message = rowData.is_deleted ? MSG_MAPPING_RESTORE_WARNING : MSG_MAPPING_DELETE_WARNING;
    setConfirmMessage(message + rowData.cpu_generation + " ?");
    setDeleteConfirmBoxFunction(true);
    setItemToBeDeleted(rowData);
  };
  const cancelDeleteItem = () => {
    setDeleteConfirmBoxFunction(false);
    setItemToBeDeleted(null);
  };
  return (
    <div className="form-wrap mt-3">
      <Breadcrumb data={breadcrumbs} disableEditTitle={true} />
      {showDeleteConfirmBox ? (
        <ConfirmBox
          actionHandler={deleteCPUGenFunction}
          handleSubmit={deleteCPUGenFunction}
          cancelDeleteItem={cancelDeleteItem}
        >
          {confirmMessage}
        </ConfirmBox>
      ) : null}
      <div className="form-group d-flex">
        <div className="col-sm-6">
          <form>
            <div className="row pl-2 pb-1">
              <div className="col-sm-11">
                <label htmlFor={""} className="mr-sm-2 mt-2">
                  <b>VMware Combine Key</b>
                </label>
                {/* add multi select dropdown */}
                <Select
                  isMulti
                  name="Combine Key"
                  options={combineKeyDetails}
                  classNamePrefix="select"
                  onChange={(e) => selectMultipleValue(e)}
                  value={selectedCombineKeys}
                  isSearchable={true}
                  isClearable={true}
                />
                <label htmlFor={"CPU Generation"} className="mr-sm-2 mt-2">
                  <b>CPU Generation </b>
                </label>
                <div className="form-group">
                  <Select
                    name="CPU Generation"
                    options={cpuGenerationDetails}
                    classNamePrefix="Select"
                    onChange={(e) => setSelectedCpuGeneration(e)}
                    value={selectedCpuGeneration}
                    isDisabled={isEditForm}
                  />

                </div>
              </div>
            </div>
            {errorMessage !== "" && (
              <div className="col-sm-10 mb-2">
                <div class="text-danger">{errorMessage}</div>
              </div>
            )}
            <div className="col-sm-12">
              <button
                type="reset"
                onClick={resetForm}
                className="btn btn-md btn-light btn-link submit-btn-inline mr-sm-2"
              >
                <i className="fa fa-refresh"></i> Reset
              </button>
              <button
                type="submit"
                className="btn btn-md btn-dark submit-btn-inline"
                // disabled={isSubmitting}
                onClick={isEditForm ? updateCPLDMapping : addCPUGenerationMapping}
              >
                {isEditForm ? "Update" : "Add"}
              </button>
            </div>
          </form>
        </div>
        <div className="col-sm-6">
          <MaterialTable
            title="CPU Generation Mappings"
            columns={[
              { title: "Combine Key", field: "vmware_combine_key" },
              { title: "CPU generation", field: "cpu_generation" }

            ]}
            data={cpuGenTableData}

            options={{
              headerStyle: {
                backgroundColor: "#e9ecef",
              },
              actionsColumnIndex: -1,
              selection: false,
              search: true,
              maxBodyHeight: 400,
            }}
            localization={{
              header: {
                actions: "Actions",
              },
            }}
            actions={[
              (rowData) => ({
                icon: "edit",
                tooltip: !rowData.is_deleted && "Edit Record",
                onClick: (e, data) => {
                  // call edit function
                  editForm(data);
                },
                hidden: !rowData?.id || rowData.is_deleted// display action only if any valid item is present
              }),
              (rowData) => ({
                icon: rowData.is_deleted ? "undo" : "delete",
                tooltip: rowData.is_deleted
                  ? "Undo Deleted Record"
                  : "Delete Record",
                onClick: (e, data) => {
                  showWarning(data);
                },
                hidden: !rowData?.id // display action only if any valid item is present
              }),
            ]}
          />
        </div>
      </div>
    </div>
  );
}

export default ManageVmwareCPUGen;
